export default __webpack_public_path__ + "static/media/oeufs.e78c77ed.jpeg";